import React, { Suspense } from 'react';
import VendorMenuBar from 'routes/vendorRe/pages/common/VendorMenuBar';
import { Outlet } from 'react-router';
import { CContainer, CSpinner } from '@coreui/react';

const VendorMainLayout = () => {
    return (
        <div>
            <VendorMenuBar />
            <div>
                <CContainer lg>
                    <Suspense fallback={<CSpinner color="primary" />}>
                        <Outlet />
                    </Suspense>
                </CContainer>
            </div>
        </div>
    );
};

export default VendorMainLayout;
